// Single source of truth for company details.
// Change a value here and it updates the header, footer, CTA band and contact page.
// PLACEHOLDER remaining: email address.

export const COMPANY = {
  name: "A4 Express Ltd",
  brand: "A4 EXPRESS",
  tagline: "UK & Ireland Transport",
  slogan: "Driven by trust. Powered by reliability.",
  phone: "0333 404 0333",
  // International form in the href so the link works from any country.
  phoneHref: "tel:+443334040333",
  email: "enquiries@a4express.co.uk",
  emailHref: "mailto:enquiries@a4express.co.uk",
  address: {
    line1: "6 Little Ilford Lane",
    city: "London",
    postcode: "E12 5PW",
    country: "United Kingdom",
  },
  companyNumber: "17335520",
  // Files in frontend/public are served from the root, so this path is the URL.
  logo: "/logo-a4-express.jpg",
  hours: {
    office: "Mon–Fri, 08:00–18:00",
    transportDesk: "24/7",
  },
};

export default COMPANY;
